/**
 * SNS Links Panel Render
 *
 * Render layer: DOM manipulation only.
 */

import type { SNSLinksPanelForm } from "./sns-links-panel-form";

export class SNSLinksPanelRender {
    /** Open the editor UI and focus the first input. */
    public static openEditor(form: SNSLinksPanelForm): void {
        const root = form.getRoot();
        const editor = form.getEditor();
        if (!editor) {
            return;
        }

        root.classList.add("is-editing");
        editor.hidden = false;

        const firstInput = form.getFirstInputInEditor();
        if (firstInput) {
            try {
                firstInput.focus();
            } catch {
                // ignore
            }
        }
    }

    /** Close the editor UI. */
    public static closeEditor(form: SNSLinksPanelForm): void {
        const root = form.getRoot();
        const editor = form.getEditor();
        if (!editor) {
            return;
        }

        root.classList.remove("is-editing");
        editor.hidden = true;
    }
}
